var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.widgetFields),function(field){return _c('WidgetFieldWrapper',{key:field.id,attrs:{"field":field,"previousSteps":{},"fieldValue":_vm.fieldValue(field.id),"configurationId":_vm.configurationId,"isGeneralConfiguration":_vm.isGeneralConfiguration},on:{"update-value":_vm.updateValue}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }